import axios from "axios";
import { Message, Loading } from "element-ui";
import { set } from "nprogress";

let loading;
let requestCount = 0;
let duration = 2 * 1000;
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

function startLoading() {
    if (requestCount === 0) {
        loading = Loading.service({
            lock: true,
            text: "数据加载中...",
            background: "rgba(0,0,0,.4)"
        });
    }
    requestCount++;
}

function stopLoading() {
    requestCount--;
    if (requestCount <= 0) {
        requestCount = 0;
        if (loading) {
            loading.close();
            loading = null;
        }
    }
}


const service = axios.create({
    baseURL:'/usercenter/api',
    timeout: 10000,
    headers: {}
});


service.interceptors.request.use(
    config => {
        startLoading();
        return config;
    },
    error => {
        console.log(error); // for debug
        stopLoading();
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        stopLoading();
        const { data } = response;
        if (response instanceof Blob) {
            return response;
        }
        return data;
    },
    error => {
        stopLoading();
        let res = error.response;
        return Promise.reject(res.data);
    }
);

export default service;